/**
 * Feature flags for controlling feature visibility based on environment and host
 */

// Allowed host IDs for Airbnb Room Type Integration in production
const AIRBNB_ROOM_TYPE_ALLOWED_HOSTS = [
  '5ca17d46124e180f8e0628e7', // Maplehome
  '5cff3d026c2cfe3641bec9fa', // Salaam
  '688c2ebd4e87eb1ffd589943', // Top Key Sunshine
  '680770206f4e2b053be7db5a', // Comfort Z
  '5e2692104be7845599b3d2fe', // for testing
  '69083aaa29ea8f03c16adf8f', // Silaslee Management Sdn Bhd
  '624bf6cf7c285914b8ac5b08', // Bobo Leisure
  '5c92ee62d694e43ea67f351c', // Top Key Management
  '65e7cb8e3a512004c59fd6be', // MW Hospitality
  '67b827361b208904d0a8ed2f', // Asdeh
  '614c39d7e5cf9a0ea83e8990', // Dehoz
  '633262dabd667445d038b2d7', // AS Home
  '6806222da4a22504b48847a3', // VS Home
  '652f600376d8a9046b48242f', // Dormeo Destinations Sdn Bhd
  '699d694a9de67e03f401337e', // Dormeo Destinations 2
  '65139590e577fc04b18baec8', // Luxpro
  '672c53785b47b804a0a282c2', // Gyden Staycation Sdn Bhd
  '689063f5cc4c3804f546b3ee', // Holma Management
  '6364ddbd68ee9f11fdf0a293', // Guestonic
  '63e9ffb3ec6f466812c22208', // Holma Suite
  '6833d1a176a31004823ec5f2', // Resandau Stay
  '643e349f4c3c57648731d04d', // Stayrene
  '607ff4010f3a7420cf0c6a77', // Stayrene Melaka
  '643a85fdabfe36368777099b', // Stayrene JB
  '68da0f642f52430567c17bff', // Stayrene Casa Forest
  '6948fcd4806d1c03ea737044', // T Journey
  '6405ab1782d3ea319d1467f1', // Yhome Solution
  '693fb9c14f42a003dc1d600a', // Tucasa Enterprise
  '6a856b2ff6b819692ef84b9c' // WANSHENGTONG DEVELOPMENT TECHNOLOGY SDN.BHD.
];

/**
 * Check if Airbnb Room Type Integration feature should be shown
 * @param {string} hostId - The host ID to check
 * @returns {boolean} - True if feature should be shown
 */
export const isAirbnbRoomTypeFeatureEnabled = hostId => {
  // In production, only show for whitelisted hosts
  return AIRBNB_ROOM_TYPE_ALLOWED_HOSTS.includes(hostId);
};
